import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import ToolTip from 'components/common/tool-tip-component';
import useOutsideClick from 'components/hooks/useOutsideClick';

const BLOCK = 'icon-dropdown';

const IconDropDown = ({
  displayIconPlaceholder,
  arrowIcon,
  onSelectOption,
  options,
  value,
  tooltip,
  disabled,
  optionSize,
}) => {
  const [displayOptions, setDisplayOptions] = useState(false);
  const [iconDropDownContainer] = useOutsideClick(() =>
    setDisplayOptions(false),
  ); // used to handle outside click

  const getHighlightedDisplayValue = (display, optionSize) => {
    const children = (
      <div className={`${BLOCK}__display-container`}>
        <div
          className={classnames(`${BLOCK}__display-highlight`, {
            [`${BLOCK}__display-highlight--disabled`]: disabled,
          })}
          style={{
            fontSize: optionSize ? `${optionSize}px` : undefined,
          }}
        >
          {display}
        </div>
        {arrowIcon}
      </div>
    );

    return tooltip.id ? (
      <ToolTip id={tooltip.id} text={tooltip.text} position={tooltip.position}>
        {children}
      </ToolTip>
    ) : (
      <>{children}</>
    );
  };
  return (
    <div
      className={classnames(`${BLOCK}__icon-dropdown-container`, {
        [`${BLOCK}__icon-dropdown-container--disabled`]: disabled,
      })}
      onClick={() => !disabled && setDisplayOptions(!displayOptions)}
      ref={iconDropDownContainer}
    >
      {value && value.icon
        ? getHighlightedDisplayValue(value.icon, optionSize)
        : getHighlightedDisplayValue(displayIconPlaceholder, optionSize)}

      {displayOptions && (
        <ul className={`${BLOCK}__list-container`}>
          {options.map((item) => {
            const listItem = (
              <li
                key={item.id}
                className={classnames(`${BLOCK}__list-container--items`, {
                  [`${BLOCK}__list-container--item-selected`]:
                    item.id === value.id,
                  [item.className]: !!item.className,
                })}
                onClick={() => onSelectOption(item)}
              >
                {item.icon && (
                  <span
                    className={classnames(
                      `${BLOCK}__list-container--items-icon`,
                    )}
                    style={{
                      fontSize: optionSize ? `${item.value}px` : undefined,
                    }}
                  >
                    {item.icon}
                  </span>
                )}
                {item.title && (
                  <div className={`${BLOCK}__list-title`}>
                    <FormattedMessage id={item.title} />
                  </div>
                )}
              </li>
            );
            return item.tooltip ? (
              <ToolTip
                key={item?.id}
                id={item?.tooltip?.id}
                text={item.tooltip.title}
                position={item?.tooltip?.position}
              >
                {listItem}
              </ToolTip>
            ) : (
              listItem
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default IconDropDown;
